import actions from "./actions";

const initState = {
  ordersExecution: [],
  loading: false,
};

export default function ordersExecutionReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.ORDERS_EXECUTION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.ORDERS_EXECUTION_SUCCESS:
      return {
        ...state,
        ordersExecution: action.ordersExecution,
        loading: false,
      };
    default:
      return state;
  }
}
